import React, {useEffect, useRef, useState, useCallback} from "react";
import DemoMTScheduler from '../pages/DemoMTSchedulerSignupProcess'; // Import the main scheduler component
import MTSchedulerSimulationMain from '../pages/MTSchedulerSimulationMain';

import PoweredBy from '../../src/assets/Images/LoginImages/PoweredBy.png'

const DemoMTSchedulerLayout = () => {
  useEffect(()=>{
    try{
      document.title = "Microtransit Simulation Scheduler";
    }
    catch(err){console.log(err);}
  }, []);
  
  return (
    <div>
      <MTSchedulerSimulationMain></MTSchedulerSimulationMain>
    </div>
  );
}

export default DemoMTSchedulerLayout;
